import { ErrorCircleIcon, AlertTriangleIcon, OpenIcon, PendingIcon, SuccessCircleCheckIcon } from '../Icon'

export const STATUS_TAG_VARIANTS = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  open: 'open',
  pending: 'pending',
  closed: 'closed',
} as const

export const STATUS_TAGS_ICON = {
  [STATUS_TAG_VARIANTS.success]: { icon: SuccessCircleCheckIcon, isFilled: true },
  [STATUS_TAG_VARIANTS.warning]: { icon: AlertTriangleIcon, isFilled: true },
  [STATUS_TAG_VARIANTS.error]: { icon: ErrorCircleIcon, isFilled: true },
  [STATUS_TAG_VARIANTS.open]: { icon: OpenIcon, isFilled: false },
  [STATUS_TAG_VARIANTS.pending]: { icon: PendingIcon, isFilled: false },
  [STATUS_TAG_VARIANTS.closed]: { icon: SuccessCircleCheckIcon, isFilled: false },
} as const
